import Skeleton from "react-loading-skeleton";
import Avis from "../components/Avis";
import { useState } from "react";

const AvisBloc = (props) => {
  const [showAll, setShowAll] = useState(false);
  if (props?.status === "loading") {
    return (
      <div className="twyny-border-bottom">
        <h3 className="grey500">
          <Skeleton width={200} height={24} /> 
        </h3>
        <div className="row mt-16">
          {[...Array(4)].map((_, key) => (
            <div className="col-md-6" key={key}>
              <div className="py-16">
                <Skeleton height={100} />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
  const avisToShow = showAll ? props.avis : props.avis?.slice(0, 6);
  return (
    <div className="twyny-border-bottom">
    
      <h3 className="grey500">
        {props?.title}    <img src="/images/star-02.svg" className="ml-8" alt="star icon" /> {props?.nbStars}
        <span className="body bold500 grey66 ml-4"> ({props?.avis?.length} avis)</span>
      </h3>
      <div className="row mt-16">
        {avisToShow?.map((avis,key) => (
        <div className="col-md-6 "  key={key}>
          <div className="py-16">
            <Avis data={avis}  />
          </div>
        </div>
      ))}
        {props?.avis?.length > 6 && (
                <div className="text-center mt-3">
                  <button
                    className="link-blue"
                    onClick={() => setShowAll(!showAll)}
                  >
                    {showAll ? "Voir moins" : "Voir toutes les avis"}
                    <br />
                    <img src="/images/down-arrow.svg" alt="down arrow icon" className={showAll ? "rotate180" :""}  />
                  </button>
                </div>
              )}
      </div>
      
    </div>
  );
};
export default AvisBloc;
